/** Character specs sharing Bao's skeleton: same bones, same leg/foot rig, different costume & proportions. */
const SKIN = {
  deep: { skin: "#6B4226", skinB: "#4A2C18", hi: "#8E5C37" },
  warm: { skin: "#7A4B2C", skinB: "#55331D", hi: "#9C6740" },
  elder: { skin: "#5E3A22", skinB: "#3F2615", hi: "#7E5435" },
  rich: { skin: "#4E2F1B", skinB: "#341E10", hi: "#6E4529" },
};

export const CHARACTERS = {
  bao: {
    name: "Bao", role: "Le héros · explorateur du Baobab", sheet: "/assets/characters/bao.jpg",
    blurb: "Courageux et doux. Chaque pas du patient fait avancer Bao.",
    scale: 1, build: 1, posture: 0, hair: "locs", top: "shirt", footwear: "boots", bottomLen: 0.58,
    extras: ["backpack", "sash", "pendant"],
    pal: { ...SKIN.deep, hair: "#16100C", top: "#F1E6CF", topB: "#D9CBAE", bottom: "#EDE3CC", bottomB: "#CDBF9F", accent: "#17A2A2", trim: "#E0B33A", shoe: "#CDB896", shoeB: "#7A5A3A", sock: "#F7F4EC", gear: "#7A4E2A" },
  },
  zola: {
    name: "Zola", role: "La compagne exploratrice", sheet: "/assets/characters/zola.jpg",
    blurb: "Curieuse, elle lit les empreintes et guide Bao dans la savane.",
    scale: 0.9, build: 0.94, posture: 0, hair: "puffs", top: "vest", footwear: "boots", bottomLen: 0.62, bottomPattern: true,
    extras: ["satchel", "compass"],
    pal: { ...SKIN.warm, hair: "#120C09", top: "#F4ECD8", topB: "#DCCFB2", vest: "#C98A3A", bottom: "#0E7C74", bottomB: "#0A5F59", accent: "#17A2A2", trim: "#E0B33A", shoe: "#D2BE9C", shoeB: "#7A5A3A", sock: "#F7F4EC", gear: "#B98E5A" },
  },
  aissa: {
    name: "Mama Aïssa", role: "L'Ancienne du village", sheet: "/assets/characters/aissa.jpg",
    blurb: "La mémoire du village. Elle confie à Bao la quête des Graines de Vie.",
    scale: 0.95, build: 1.02, posture: 4, hair: "headwrap", top: "wrap", footwear: "sandals", skirt: 128, bottomPattern: true,
    extras: ["cane", "beads"],
    pal: { ...SKIN.elder, hair: "#D8D4CC", top: "#C7892F", topB: "#9E6A22", bottom: "#C7892F", bottomB: "#9E6A22", wrap: "#2C3E78", waxRing: "#0E7C74", accent: "#17A2A2", trim: "#E0B33A", shoe: "#8A5A30", shoeB: "#5E3A1C", gear: "#6E4A2A" },
  },
  kofi: {
    name: "Baba Kofi", role: "Le potier du village", sheet: "/assets/characters/kofi.jpg",
    blurb: "Mains d'argile et cœur joyeux. Il façonne les jarres de la rivière.",
    scale: 1.04, build: 1.12, posture: 1, hair: "kufi", beard: true, top: "apron", footwear: "sandalboots", bottomLen: 0.86,
    extras: ["pot"],
    pal: { ...SKIN.rich, hair: "#BDB8AE", top: "#7B5236", topB: "#5C3B25", apron: "#B5653A", bottom: "#E9DEC6", bottomB: "#C9BB9C", accent: "#17A2A2", trim: "#E0B33A", shoe: "#8A5A30", shoeB: "#5E3A1C", gear: "#B5653A" },
  },
  nala: {
    name: "Nala", role: "Gardienne des Graines de Vie", sheet: "/assets/characters/nala.jpg",
    blurb: "Elle veille sur les Graines de Vie et récompense chaque progrès.",
    scale: 1.02, build: 0.96, posture: 0, hair: "crown", top: "cape", footwear: "sandals", skirt: 84,
    extras: ["seed", "cuffs"],
    pal: { ...SKIN.warm, hair: "#120C09", top: "#F1E6CF", topB: "#D9CBAE", bottom: "#D29A3A", bottomB: "#A9772A", cape: "#0E7C74", capeB: "#0A5F59", accent: "#17A2A2", trim: "#E0B33A", shoe: "#8A5A30", shoeB: "#5E3A1C", leaf: "#3E9F6E", gear: "#E0B33A" },
  },
};

export const CAST = Object.keys(CHARACTERS);
